import {TrackingManagerV1} from '@volkswagen-onehub/tracking-service'
import {checkTrackingManager} from './setTracking'

let localTrackingManager: TrackingManagerV1
export const setTrackingServiceManager = (
    trackingManager: TrackingManagerV1
) => {
    localTrackingManager = trackingManager
}

export default function setLocalTracking(
    // tslint:disable-next-line:no-any
    trackingEvent: string,
    data: object
): void {
    // `tracking` is an optional Feature Service: without it, skip tracking
    // instead of breaking the component that tracks
    if (!checkTrackingManager(localTrackingManager)) {
        return
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    localTrackingManager.track(trackingEvent, data)
}
